import React, { useContext } from 'react';
import { Link } from '@xo-union/tk-component-buttons';
import BasePublishWebsiteModalContent from '../BaseModalContent/BasePublishWebsiteModalContent';
import styles from './PublishWebsiteModalContentVariant.scss';
import { TrackingContext } from '../../../../../TrackingContext';
import CopyToClipboardButton from '../../../../CopyToClipboardButton/CopyToClipboardButton';
import { useRegistrySummaryQuery } from '../../../../../generated/graphql';
import registryInfo from '../../../../../helpers/registryInfo';

interface PublishWebsiteModalContentVariantProps {
  wwsUrl?: string;
}

const PublishWebsiteModalContentVariant = ({ wwsUrl }: PublishWebsiteModalContentVariantProps) => {
  const registryUrlHref = 'https://www.theknot.com/registry/store/popular-gifts?f_price=50.00_99.99';

  const { data: registryData } = useRegistrySummaryQuery();
  const { hasAnyRegistry } = registryInfo(registryData?.registrySummary);

  const noRegistryItemsCopy = "Next, let's set up your registry so guests can shop gifts right from your site.";
  const hasRegistryItemsCopy = 'Next, add more registry gifts for guests to shop right from your site.';
  const registryCopy = hasAnyRegistry ? hasRegistryItemsCopy : noRegistryItemsCopy;

  const { track } = useContext(TrackingContext);

  const linkClicked = () => {
    track('CTA Clicked', { reason: hasAnyRegistry ? 'wws_yes_registry' : 'wws_no_registry' });
  };

  const onUrlCopy = () => {
    track('Website Link Copied', {
      source: 'wws_publish_modal',
    });
  };

  return (
    <BasePublishWebsiteModalContent
      header="Website published!"
      textContent={
        <>
          <div>Share the link so everyone has all the details.</div>
        </>
      }
      bottomContent={
        <>
          <div className={styles.PublishWebsiteModalContent__BottomSpacer} />
          <div
            className={styles.PublishWebsiteModalContent__WwsUrl__Container}
            data-testid="PublishWebsiteModalContent__WwsUrl__Container"
          >
            <div className={styles.PublishWebsiteModalContent__WwsUrl__Spacer} />
            <div
              className={styles.PublishWebsiteModalContent__WwsUrl__UrlText}
              data-testid="PublishWebsiteModalContent__WwsUrl__UrlText"
            >
              {wwsUrl || ''}
            </div>
            <CopyToClipboardButton
              textToCopy={wwsUrl || ''}
              onCopy={onUrlCopy}
              onCopyMessage="Copied website url to clipboard"
              dataTestId="PublishWebsiteModalContent__WwsUrl__CopyButton"
              ariaLabel="Copy website url"
            />
          </div>
          {registryCopy}
          <Link
            size="md"
            href={registryUrlHref}
            target="_blank"
            data-testid="PublishWebsiteModalContent__RegistryLink"
            onClick={linkClicked}
          >
            Add gifts
          </Link>
        </>
      }
    />
  );
};

export default PublishWebsiteModalContentVariant;
